<template>
  <b-row >
    <b-col
      class="col-12 col-sm-6 col-md-6 col-lg-3 col-xxl-3"
      v-for="content, index in contents"
      :key="index"
    > 
      <b-card
        no-body
        style="box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1) !important"
        class="card hover-card card-image-content card-type-content"
      >
      <b-link @click="$emit('action-add-form', content)">
        <b-img-lazy v-if="!content.image_content_url" :id="`view${index}`" class="card-image-content" :src="getPreview(content)" @error.native="errorLoad(index)" />

        <video 
        v-else-if="content.image_content_url"
        muted 
        playsinline
        :ref="`video_animation_${index}`" 
        :src="content.image_content"
        @mouseenter="playVideoContents(index)"
        @mouseleave="pauseVideo(index)"
        class="card-image-content"
        >
      </video>
       
      </b-link>
      <div>
        <div class="mx-1 position-container-actions">
          <b-form-checkbox
            v-model="checked_uuids"
            :value="content.uuid"
            :checked="checked_uuids.includes(content.uuid)"
            @change="$emit('toggle-check', content.uuid)"
            class="custom-control-primary"
          >
          </b-form-checkbox>
          <feather-icon
            @click="$emit('action-remove', content.uuid)"
            icon="XIcon"
            size="16"
            class="align-middle text-secondary position-absolute cursor-pointer delete-creator-views"
          />
        </div>
        <interactions
          :index="index"
          :content="content"
          />
        </div>
      </b-card>
    </b-col>
    <div class="col-12 row m-0 p-0" v-if="loading_contents && contents.length < total_results">
      <b-col class="col-12 col-sm-6 col-lg-4 col-xl-3" v-for="i in 4" :key="i">
        <b-card class="card-skeleton">
          <b-skeleton class="skeleton profile-avatar mb-2"></b-skeleton>
          <b-skeleton class="skeleton h1 col-10"></b-skeleton>
          <b-skeleton class="skeleton col-8 mb-5"></b-skeleton>

          <b-skeleton class="skeleton col-4"></b-skeleton>
          <b-skeleton class="skeleton col-4 mb-7"></b-skeleton>

          <div class="d-flex w-100 mb-1">
            <b-skeleton type="button" class="skeleton w-100 mr-2"></b-skeleton>
            <b-skeleton type="button" class="skeleton w-100 ml-2"></b-skeleton>

          </div>
        </b-card> 
      </b-col>
    </div>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BImgLazy, BLink, BFormCheckbox, BSkeleton
} from 'bootstrap-vue'
import service_campaign from "@/services/campaign";
import Interactions from './Interactions.vue';
import { getMotivationalPhrase } from '@/libs/utils/others'
import { isVideo } from '@/libs/utils/formats';
import { verifyAsset, } from '@/libs/utils/urls'


export default {
  name: 'ContentsView',
  components: {
    BRow,
    BCol,
    BCard,
    Interactions,
    BImgLazy,
    BLink,
    BFormCheckbox,
    BSkeleton,
  },
  props: {
    checked_uuids: {
      type: Array,
      default: () => [],
    },
    filter_category: {
      type: String,
    },
    query_search: {
      type: String,
    },
    per_page: {
      type: Number,
    }
  },

  data() {
    return {
      verifyAsset,
      isVideo,
      getMotivationalPhrase,
      contents: [],
      backgroundDefault: require("@/assets/images/dashboard/reload_img.svg"),
      interval_loading: null,
      current_page: 1,
      total_results: 0,
      loading_contents: false,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.checkScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.checkScroll);
  },
  created () {
    this.loading_contents = true;
    this.$vs.loading({
      type: 'sound',
      background: 'rgba(255, 255, 255, 1)',
      text: getMotivationalPhrase(),
    });

    this.interval_loading = setInterval(() => {
      const prev_loading = document.getElementsByClassName('con-vs-loading')[0]

      if (prev_loading) {
        prev_loading.classList.add('fade-out');
        setTimeout(function() {
          prev_loading.remove()
        }, 500);

        this.$vs.loading({
          type: 'sound',
          background: 'rgba(255, 255, 255, 1)',
          text: getMotivationalPhrase(),
        });
      }
    }, 5000);
    service_campaign.getCampaignManage(this.$route.params.uuid, this.filter_category, this.query_search, this.current_page, this.per_page).then((response) => {
      const total_contents = this.formatContents(response.results);
      this.contents = total_contents;
      this.total_results = response.count;
      setTimeout(() => {        
        clearInterval(this.interval_loading)
        this.$vs.loading.close();
        this.loading_contents = false;
      }, 500);
    })
  },
  methods: {
    playVideoContents(index) {
      const video = this.$refs[`video_animation_${index}`][0];
      if (video && video.play) {
        video.play().catch(err => {
          console.warn('No se pudo reproducir el video:', err);
        });
      }
    },
    pauseVideo(index) {
      const video = this.$refs[`video_animation_${index}`][0];
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    },
    checkScroll() {
      const scrollableHeight = document.body.scrollHeight - window.innerHeight;
      const scrollPosition = window.scrollY;

      const load_more = scrollableHeight - scrollPosition <= 100 && !this.loading_contents && this.contents.length < this.total_results;

      if (load_more) {
        this.loading_contents = true;
        this.current_page += 1;
        this.getScrollInfinite();
      }
    },
    getScrollInfinite() {
      service_campaign.getCampaignManage(this.$route.params.uuid, this.filter_category, this.query_search, this.current_page, this.per_page).then((response) => {
        const total_contents = this.formatContents(response.results);
        this.contents = [...this.contents, ...total_contents];
        this.total_results = response.count;
      })
        .finally(() => {
          this.loading_contents = false;
        });
    },
    
    getUrl(content) {
      if (content.url_info) return content.url_info
      if (content.image_content) return content.image_content
      return null
    },
    getPreview(content) {
      const preview = content.content_preview_url;

      if (preview && preview.startsWith('http')) {
        return verifyAsset(preview);
      } else if (content.image_content && content.image_content.startsWith('http')) {
        return verifyAsset(content.image_content);
      } else {
        return this.backgroundDefault;
      }
    },
    errorLoad(index) {
      this.contents[index].content_preview_url = this.backgroundDefault;
    },
    getMetrics(content) {
      const metrics = [
        {name: 'number_of_likes', value: content.number_of_likes},
        {name: 'number_of_comments',  value: content.number_of_comments},
        {name: 'number_of_shares', value: content.number_of_shares},
        {name: 'number_of_rts', value: content.number_of_rts},
        {name: 'number_of_times_favs', value: content.number_of_times_favs},
        {name: 'number_of_times_saved', value: content.number_of_times_saved},
        {name: 'number_of_views', value: content.number_of_views},  
        {name: 'number_of_dislikes', value: content.number_of_dislikes},
        {name: 'number_of_clicks_to_stickers', value: content.number_of_clicks_to_stickers},
        {name: 'number_of_clicks_to_the_link', value: content.number_of_clicks_to_the_link},
        {name: 'number_of_reproductions', value: content.number_of_reproductions},
        {name: 'number_of_impressions', value: content.number_of_impressions},
        {name: 'number_of_prints', value: content.number_of_prints},
        {name: 'number_of_responses', value: content.number_of_responses},
        {name: 'scope_number', value: content.scope_number},
        {name: 'number_of_interactions', value: content.number_of_interactions},
      ]
      return metrics.filter((item) => item.value > 0 && item.value !== null)
    },
    getUrlContent(content) {
      if (content.url_info) return content.url_info
      else if (content.image_content) return content.image_content
      return ''
    },
    getNetworkByUrl(url) {
      if (url.includes('instagram.com')) return 'instagram'
      else if (url.includes('spotify.com')) return 'spotify'
      else if (url.includes('twitter.com')) return 'twitter'
      else if (url.includes('facebook.com')) return 'facebook'
      else if (url.includes('youtube.com')) return 'youtube'
      else if (url.includes('twitch.tv')) return 'twitch'
      else if (url.includes('tiktok.com')) return 'tiktok'
      else return 'brandme'
    },
    formatContents(influencers) {
      const data = []
      influencers.forEach(influencer => {
        influencer.content.forEach((content) => {
          if (content.status !== 'content_published') return;
          const url = this.getUrlContent(content)
          if (!content.content_preview_url) {
            if (content.content_type !== 'story') 
              content['content_preview_url'] =  content.content_preview_url ? content.content_preview_url : this.backgroundDefault;
            else if (!isVideo(content.image_content)) 
              content['content_preview_url'] =  content.image_content ? content.image_content : this.backgroundDefault;
            else
              content['content_preview_url'] =  content.image_content ? content.content_preview_url : this.backgroundDefault;
          }
          content['influencer'] = influencer.influencer
          content['network_by_url'] = this.getNetworkByUrl(url);
          content['metrics'] = this.getMetrics(content)
          data.push(content)
        })
      })
      console.log('Formatted contents:', data);
      return data;
    }
  }
}
</script>

<style scoped lang="scss">
.delete-creator-views {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 9
}
.card-skeleton {
  background-color: #fff;
  .card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
    border-radius: .4rem;
  }
  .skeleton {
    &.profile-avatar {
      width: 200px;
      height: 200px;
      border-radius: 100%;
    }
  }
}
.position-container-actions {
  position: relative;
  bottom: 20.5em;;
  z-index: 9
}
.hover-card:hover {
  transform: scale(1.05);
  transition: all 500ms;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 12px 28px 0px,
    rgba(0, 0, 0, 0.1) 0px 2px 4px 0px,
    rgba(255, 255, 255, 0.05) 0px 0px 0px 1px inset;
}
.card-image-content {
  width: 100%;
  object-fit: cover;
  height: 300px;
  border-radius: 1%;
}
.card-type-content{
 display: flex;
 height: 90%;
 border: 1px solid #eee5e5;
}
</style>
